var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-icon",
    {
      directives: [
        {
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: _vm.token,
          expression: "token",
          arg: "copy",
        },
        {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: _vm.onCopy,
          expression: "onCopy",
          arg: "success",
        },
      ],
      staticClass: "mr-2",
      staticStyle: { cursor: "pointer" },
      attrs: { color: "info darken-3" },
      on: { click: _vm.handleClick },
    },
    [_vm._v(" mdi-content-copy ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }